import React from "react";
import { Button, Card, Dropdown, Table, Tabs, Tag } from "antd";
import { useGetUserDepositsQuery } from "store/api";
import { FileDown } from "lucide-react";
import { handleCsvExport, handleExcelExport, handlePdfExport } from "utils";

const Transactions = () => {
  const { data, isFetching } = useGetUserDepositsQuery("deposits");
  const items = [
    {
      key: "csv",
      label: "As CSV",
      onClick: () => handleCsvExport(data, "transactions"),
    },
    {
      key: "pdf",
      label: "As Pdf",
      onClick: () =>
        handlePdfExport(data, "transactions", "landscape", [
          "id",
          "serviceProvider",
        ]),
    },
    {
      key: "excel",
      label: "As Excel",
      onClick: () =>
        handleExcelExport(data, "transactions", ["id", "serviceProvider"]),
    },
  ];
  return (
    <div>
      {" "}
      <Card
        className="!font-sans"
        title={
          <div className="flex items-center justify-between">
            <h3>Transactions</h3>
            <Dropdown menu={{ items }}>
              <Button className="!min-h-9">
                {" "}
                Export Transactions <FileDown className="w-4 h-4" />
              </Button>
            </Dropdown>
          </div>
        }
      >
        <Tabs defaultActiveKey="1" className="font-sans">
          <Tabs.TabPane tab="All Transactions" key="1">
            <Table
              size="small"
              pagination={{ pageSize: 10 }}
              columns={[
                {
                  title: "ID",
                  dataIndex: "transactionId",
                  key: "transactionId",
                },
                {
                  title: "Amount",
                  dataIndex: "amount",
                  key: "amount",
                },
                {
                  title: "Account Number",
                  dataIndex: "accountNumber",
                  key: "accountNumber",
                },
                {
                  title: "Transaction Type",
                  dataIndex: "transactionType",
                  key: "transactionType",
                  render: (text) => (
                    <Tag
                      color={text === "savings" ? "green" : "red"}
                      className="capitalize"
                    >
                      {text}
                    </Tag>
                  ),
                },
                {
                  title: "Transaction Date",
                  dataIndex: "transactionDate",
                  key: "transactionDate",
                  render: (text: string | number | Date) => {
                    // Sun, Jul 13th 2025, 4:54 pm
                    return new Date(text).toLocaleString("en-US", {
                      weekday: "short",
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    });
                  },
                },
                {
                  title: "Status",
                  dataIndex: "paymentStatus",
                  key: "paymentStatus",
                  render: (text) => (
                    <Tag
                      color={text === "approved" ? "green" : "yellow"}
                      className="capitalize"
                    >
                      {text}
                    </Tag>
                  ),
                },
              ]}
              dataSource={data || []}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Self Reported Transactions" key="2">
            <Table
              size="small"
              pagination={{ pageSize: 10 }}
              columns={[
                {
                  title: "ID",
                  dataIndex: "transactionId",
                  key: "transactionId",
                },
                {
                  title: "Amount",
                  dataIndex: "amount",
                  key: "amount",
                },
                {
                  title: "Account Number",
                  dataIndex: "accountNumber",
                  key: "accountNumber",
                },
                {
                  title: "Transaction Type",
                  dataIndex: "transactionType",
                  key: "transactionType",
                  render: (text) => (
                    <Tag
                      color={text === "savings" ? "green" : "red"}
                      className="capitalize"
                    >
                      {text}
                    </Tag>
                  ),
                },
                {
                  title: "Transaction Date",
                  dataIndex: "transactionDate",
                  key: "transactionDate",
                  render: (text: string | number | Date) => {
                    // Sun, Jul 13th 2025, 4:54 pm
                    return new Date(text).toLocaleString("en-US", {
                      weekday: "short",
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    });
                  },
                },
                {
                  title: "Status",
                  dataIndex: "paymentStatus",
                  key: "paymentStatus",
                  render: (text) => (
                    <Tag
                      color={text === "approved" ? "green" : "yellow"}
                      className="capitalize"
                    >
                      {text}
                    </Tag>
                  ),
                },
              ]}
              dataSource={data || []}
              loading={isFetching}
            />
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default Transactions;
